<template><menu-form /></template>
<script>
import MenuForm from './MenuForm.vue'

export default { components: { MenuForm } }
</script>
